<template>
  <div class="page-body overflow-visible">
    <template v-if="isBusy || (items && items.length > 0)">
      <div class="page-table-container overflow-visible">
        <b-table
          id="worker-costs"
          ref="worker-costs"
          class="custom-table mb-0"
          :busy="isBusy"
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-compare="sortPeriodCompare"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"/>
              <strong>Загрузка</strong>
            </div>
          </template>

          <template #cell(worker_cost_type_id)="row">
            <worker-cost-type-select
              id="worker-cost-type-select"
              ref="worker_cost_type_select"
              :is-disabled="isDisabled"
              @onSelect="onSelectWorkerCostType($event, row)"
              :id="row.item.worker_cost_type_id"
            />
          </template>

          <template #cell(period)="row">
            <div style="display: flex;align-items: center;justify-content: left;">
              <b-form-input
                id="input_start_date"
                size="sm"
                class="worker-cost-width"
                :disabled="isDisabled"
                type="date"
                v-model.date="row.item.start_date"
              />
              <div class="mx-1">-</div>
              <b-form-input
                id="input_end_date"
                size="sm"
                class="worker-cost-width"
                :disabled="isDisabled"
                type="date"
                v-model.date="row.item.end_date"
              />
            </div>
          </template>

          <template #cell(sum)="row">
            <b-form-input
              id="input_sum"
              size="sm"
              class="worker-cost-width"
              :disabled="isDisabled"
              autocomplete="off"
              v-model.number="row.item.sum"
            />
          </template>

          <template #cell(comment)="row">
            <b-form-input
              id="input_comment"
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.comment"
            />
          </template>

          <template #head(action)="row">
            <b-btn variant="link" style="color: #1A9167 !important; text-decoration: none !important;" :disabled="isDisabled" @click.stop="onAddCost()">
              <v-icon name="buttons/plus" :size="12" class="mr-1"/>
              Добавить
            </b-btn>
          </template>

          <template #cell(action)="row">
            <b-button variant="link" @click="onRemoveCost(row)" :disabled="isDisabled">
              <v-icon name="buttons/trash" :size="16"/>
            </b-button>
          </template>
        </b-table>
      </div>

      <div class="page-pagination overflow-visible-context">
        <pagination-footer
          :total-rows="items.length"
          :per-page="perPage"
          @per-page-change="onPerPageChange"
        />
      </div>
    </template>

    <div v-else class="empty-state-container">
      <v-icon name="navbar/empty_table" :size="90"/>
      <h5>Нет добавленных расходов.</h5>
      <p>Добавьте расходы исполнителя прямо сейчас</p>
      <b-btn class="custom-btn-primary mt-1" :disabled="isDisabled" @click.stop="onAddCost()">
        <v-icon name="buttons/plus" :size="12" class="mr-1"/>
        Новый расход
      </b-btn>
    </div>
  </div>
</template>

<script>
import workers from "../../network/workers";
  import dateFormatter from "../../utilites/dateFormatter";
  import helpers from "../../utilites/helpers";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
    import WorkerCostTypeSelect from "../Catalogs/WorkerCostTypes/WorkerCostTypeSelect";


export default {
  name: "WorkerCosts",
  components: { PaginationFooter, WorkerCostTypeSelect },
  mixins: [
    workers,
    dateFormatter, helpers
  ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      workerId: 0,
      isBusy: false,
      items: [],
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          key: 'worker_cost_type_id',
          label: 'Тип расхода',
          class: 'widthCostType',
          sortable: false,
        },
        {
          key: 'period',
          label: 'Период',
          class: 'worker-cost-width',
          sortable: true,
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'worker-cost-width',
          sortable: false,
        },
        {
          key: 'comment',
          label: 'Комментарий',
          sortable: false,
        },
        {
          key: 'action',
          tdClass: 'align-bottom',
          sortable: false,
        },
      ],
      sortBy: 'period',
      sortDesc: true,
    }
  },
  methods: {
    configure(workerId) {
      this.workerId = workerId;
      this.getCosts();
    },
    async getCosts() {
      this.isBusy = true;
      const result = await this.getWorkerCostsById(this.workerId);
      this.isBusy = false;

      if (result.data == null) return;

      let costs = result.data.items;

      costs.forEach(cost => {
        cost.start_date = this.formatDate(this.getDateFromServerString(cost.start_date));
        cost.end_date = this.formatDate(this.getDateFromServerString(cost.end_date));
      });

      this.items = costs;
    },
    onAddCost() {
      const cost = {
        worker_id: 0,
        worker_cost_type_id: 0,
        worker_cost_type_name: 0,
        start_date: this.formatDate(new Date()),
        end_date: this.formatDate(new Date()),
        sum: null,
        comment: ''
      };
      this.items.unshift(cost);
      this.setTableOrder();
    },
    onRemoveCost(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление расходов исполнителя";
      const message = `${this.$t("Вы уверены, что хотите удалить расход:")} ${this.deleteRow.worker_cost_type_name}?`;
      this.showModalDelete(title, message, () => {
        const index = this.items.findIndex(item => item === row.item);
        this.items.splice(index, 1);
      });
    },
    async saveCosts(workerId) {
      let costs = this.items;

      costs.forEach(cost => {
        cost.start_date = this.getDateToServer(cost.start_date).toISOString();
        cost.end_date = this.getDateToServer(cost.end_date).toISOString();
      });

      return await this.postWorkerCosts(costs, workerId);
    },
    onSelectWorkerCostType(costType, row) {
      if (costType != null) {
        row.item.worker_cost_type_id = costType.id;
        row.item.worker_cost_type_name = costType.name;
      } else {
        row.item.worker_cost_type_id = 0;
        row.item.worker_cost_type_name = '';
      }
    },
    setTableOrder() {
      this.sortBy = 'period';
      this.sortDesc = true;
      this.currentPage = 1;
    },
    onPerPageChange(newPerPage) {
      this.perPage = Number(newPerPage);
      this.currentPage = 1;
    },
  }
}
</script>

<style>
.worker-cost-width {
  width: 140px;
}

#worker-costs td {
  text-align: center;
}

#worker-costs th {
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/Workers/WorkerCosts.vue